/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
// Event name definitions
export const ExceptionEventName = 'exception';
